import { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react';

const host = 'https://datetime.api.pandora.com.br';

function useNow() {
    const [initialized, setInitialized] = useState(false);
    const datetime = useRef(new Date('2000-01-01'));
    const ativo = useRef(false);

    useLayoutEffect(() => {
        ativo.current = true;

        return () => {
            ativo.current = false;
        };
    }, []);

    useEffect(() => {
        function atualizarRelogio(data) {
            if (!ativo.current) {
                return;
            }

            datetime.current = data;
            setInitialized(true);
        }

        function usarRelogioLocal(error) {
            console.warn('Não foi possível sincronizar o relógio com o servidor. Usando relógio local.', error);
            atualizarRelogio(new Date());
        }

        fetch(host, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Erro ao sincronizar relógio: ${response.status}`);
                }
                return response.json();
            })
            .then(response => {
                const serverNow = new Date(response.now);
                if (!response.now || Number.isNaN(serverNow.getTime())) {
                    throw new Error('Resposta inválida ao sincronizar relógio');
                }
                atualizarRelogio(serverNow);
            })
            .catch(usarRelogioLocal);
    }, []);

    useEffect(() => {
        if (initialized) {
            const interval = setInterval(() => {
                datetime.current = new Date(datetime.current.getTime() + 1000);
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [initialized])


    const now = useCallback(() => {
        return datetime.current;
    },[])

    return { now, isReady: initialized };
}

export default useNow;
